import { container } from '@hub-la/fe-container'
import { TelegramVerificationProvider, VerificationQRCodePage } from '@hub-la/fe-telegram-verification'
import { withRoleplayRedirect } from '../components/roleplay-redirect'

export const TelegramVerificationQRCodeInit = withRoleplayRedirect(() => {
  return (
    <TelegramVerificationProvider container={container}>
      <VerificationQRCodePage />
    </TelegramVerificationProvider>
  )
})
